import {
  AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges,
  Output, QueryList, ViewChildren
} from '@angular/core';
import { LinkChip } from '../staff-links';

// Selected links as chips, at most two rows; the rest collapse into "+N more" (BLU-64)
@Component({
  selector: 'app-link-chips',
  templateUrl: './link-chips.component.html',
  styleUrls: ['./link-chips.component.scss']
})
export class LinkChipsComponent implements OnChanges, AfterViewChecked {
  @Input() chips: LinkChip[] = [];
  @Input() readonly = false;
  @Output() remove = new EventEmitter<LinkChip>();

  @ViewChildren('chip', { read: ElementRef }) chipEls: QueryList<ElementRef<HTMLElement>>;

  visibleCount = Infinity;
  private measurePending = true;
  // "+N more" text, already translated for the hidden count
  @Input() moreLabel: (hidden: number) => string = hidden => `+${hidden}`;

  constructor(private cdr: ChangeDetectorRef) { }

  get visibleChips(): LinkChip[] {
    return this.chips.slice(0, this.visibleCount);
  }

  get hiddenCount(): number {
    return Math.max(0, this.chips.length - this.visibleCount);
  }

  ngOnChanges(): void {
    // render every chip once, then cut to two rows
    this.visibleCount = Infinity;
    this.measurePending = true;
  }

  ngAfterViewChecked(): void {
    if (!this.measurePending || !this.chipEls) {
      return;
    }
    const els = this.chipEls.map(ref => ref.nativeElement);
    // hidden modal: nothing has a size yet, measure on a later check
    if (els.length === 0 || els[0].offsetParent === null) {
      return;
    }
    this.measurePending = false;
    const rowTops = Array.from(new Set(els.map(el => el.offsetTop))).sort((a, b) => a - b);
    if (rowTops.length <= 2) {
      return;
    }
    const firstOnThirdRow = els.findIndex(el => el.offsetTop >= rowTops[2]);
    // leave room on the second row for the "+N more" chip
    this.visibleCount = Math.max(1, firstOnThirdRow - 1);
    this.cdr.detectChanges();
  }
}
